/*
  Набор валидаторов для vuetify

  Использование:
  this.$rules
*/
function removeSpaces(str) {
  if (!str) return '';

  return typeof str === 'string' ? str.replace(/ /g, '') : str;
}

const userNameRegex = /^[a-zA-Z0-9-_]+$/;
const emailNameRegex = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
const dateTimeRegex = /\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) (2[0-3]|[01]\d):[0-5]\d/;

const RULES = {
  max(maxVal) {
    return (v) => (v <= maxVal || `Максимально допустимое значение ${maxVal}`);
  },
  min(minVal) {
    return (v) => (v >= minVal || `Минимально допустимое значение ${minVal}`);
  },
  emailConfirm(email) {
    return (v) => v === email || 'Email должен совпадать';
  },
  maxSymbols(count) {
    return (v) => ((v || '').length <= count || `Поле должно содержать не более ${count} символов`);
  },
  containSymbols(count) {
    return (v) => ((v || '').length === count || `Поле должно содержать ${count} символов`);
  },
  minSymbols(count) {
    return (v) => ((v || '').length >= count || `Поле должно содержать не менее ${count} символов`);
  },
  minMaxSymbols(min, max) {
    return (v) => (
      ((v || '').length >= min && (v || '').length <= max)
      || `Поле должно содержать не меньше ${min} символов и не больше ${max}`
    );
  },
  username: (v) => (
    userNameRegex.test(v)
    || `
      Вы указали недопустимые символы. Допустима латиница в нижнем регистре и символ "-".
      Пожалуйста, введите другое значение в данное поле...
    `
  ),
  usernameOrEmail: (v) => (
    (userNameRegex.test(v) || emailNameRegex.test(v))
    || `
      Вы указали недопустимые символы. Допустима латиница в нижнем регистре и символ "-".
      Пожалуйста, введите другое значение в данное поле...
    `
  ),
  dateTime: (v) => (
    (dateTimeRegex.test(v) || v === null)
    || `
      Вы указали недопустимые символы в полях "дата" или "время".
      Пожалуйста, введите другое значение...
    `
  ),
  required: (value) => {
    const text = 'Поле обязательно для заполнения';
    if (Array.isArray(value)) {
      return Boolean(value.length) || text;
    }
    if (value && typeof value === 'object') {
      // value.name - в случае если файл
      return Boolean(Object.values(value).length || value.name) || text;
    }
    return value === 0 || !!value || text;
  },
  requiredCustom(text = 'Поле обязательно для заполнения') {
    return (v) => (Array.isArray(v) ? !!v.length : v === 0 || !!v) || text;
  },
  email: (v) => emailNameRegex.test(v) || 'Email введен неверно',
  emailRepeat: (v) => /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/.test(v),
  url: (v) => /^(ftp|http|https):\/\/[^ "]+$/.test(v) || 'URL адрес введен неверно',
  passportSeries: (v) => v.length === 4 || 'Поле должно содержать 4 символа',
  passportNumber: (v) => v.length === 6 || 'Поле должно содержать 6 символов',
  onlyNumbers: (v) => (/^[0-9]+$/.test(v)) || 'Поле должно содержать только числа',
  phoneNumber: (v) => (
    /^(\+7|7|8){1}?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/.test(v) || 'Номер телефона введён не верно'
  ),
  same: (value, message) => (v) => (
    removeSpaces(v) === removeSpaces(value) || message || 'Поля не совподают'
  ),
  onlyCyrillic: (v) => (
    /^[а-яА-ЯёЁ\- ]+$/.test(v) || 'Допустимо использование исключительно кириллицы без цифр и дополнительных знаков'
  ),
};

export default {}.install = (Vue) => {
  Vue.prototype.$rules = RULES;
};
